/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function DeviceModelTableConfig($q, $translate, $mdDialog, $document, $state, toast, types, utils, tkDialogs, userService,
                                             deviceModelService) {

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(params) {
        var deferred = $q.defer();
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;
        var tableConfiguration = createDeviceModelConfig(scope, access, params);
        deferred.resolve(tableConfiguration);
        return deferred.promise;
    }

    function createDeviceModelConfig(scope, access, params, entityTitle) {

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.device_model,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                { key: 'createdTime',
                    title: 'entity.createdTime'},
                { key: 'manufacturer',
                    title: 'device-model.manufacturer'},
                { key: 'name',
                    title: 'device-model.name'},
                { key: 'type',
                    title: 'device-model.type'},
                { key: 'deviceClass',
                    title: 'device-model.device-class',
                    cellContentFunction: (value) => $translate.instant(types.deviceClass[value].name)
                }
            ],

            loadEntities: () => {return deviceModelService.getCustomerDeviceModels()},
            loadEntity: (entityId) => {return deviceModelService.getDeviceModel(entityId)},
            saveEntity: (entity) => {return deviceModelService.saveDeviceModel(entity)},
            deleteEntity: (entityId) => {return deviceModelService.deleteDeviceModel(entityId)},

            addEnabled: () => {
                return access == types.access.admin;
            },
            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('device-model.delete-device-model-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('device-model.delete-device-model-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('device-model.delete-device-models-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('device-model.delete-device-models-text');
            }

        };

        tableConfiguration.actionCellDescriptors = [
        ];

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function getTitle(scope, entityTitle) {
        var title = $translate.instant('device-model.device-models');

        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + title;
        }
        return title;
    }

}



// WEBPACK FOOTER //
// ./src/app/device-model/device-model-table.config.js